(function () {
  'use strict';

  /* ── Helpers ──────────────────────────────────────────── */
  function moneyFormat(cents) {
    // Shopify returns cents as integer; format as $X.XX CAD
    return '$' + (cents / 100).toFixed(2);
  }

  function updateCartBadge(count) {
    var badge = document.querySelector('.cart-count');
    if (!badge) return;
    badge.textContent = count;
    badge.dataset.count = count;
  }

  function fetchCart(cb) {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(cb)
      .catch(function() {});
  }

  /* ── AJAX Add to Cart (product cards) ─────────────────── */
  function initCardATC() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.product-card__atc');
      if (!btn) return;

      var variantId = btn.dataset.variantId;
      if (!variantId) return;

      // State: adding
      btn.classList.add('is-adding');
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        // State: added
        btn.classList.remove('is-adding');
        btn.classList.add('is-added');

        // Refresh cart count in header
        fetchCart(function(cart) { updateCartBadge(cart.item_count); });

        // Reset button after 2s
        setTimeout(function() {
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 2000);
      })
      .catch(function() {
        btn.classList.remove('is-adding');
        btn.disabled = false;
      });
    });
  }

  /* ── AJAX Cart: qty +/− and remove ───────────────────── */
  function initCartControls() {
    var itemsEl    = document.getElementById('cart-items');
    var countEl    = document.getElementById('cart-item-count');
    var subtotalEl = document.getElementById('cart-subtotal');
    var totalEl    = document.getElementById('cart-total');
    var rootEl     = document.getElementById('cart-root');
    if (!itemsEl) return; // not on cart page

    function cartChange(key, qty) {
      // Find and dim the row
      var row = itemsEl.querySelector('[data-key="' + key + '"]');
      if (row) row.classList.add('is-updating');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        updateCartBadge(cart.item_count);

        if (cart.item_count === 0) {
          // Show empty state
          rootEl.innerHTML =
            '<div style="text-align:center;padding:80px 0;">' +
            '<p style="font-family:var(--font-display);font-size:36px;letter-spacing:2px;color:var(--white);margin-bottom:16px;">YOUR CART IS EMPTY</p>' +
            '<p style="color:rgba(240,237,230,0.35);margin-bottom:36px;">Looks like you haven\'t added anything yet.</p>' +
            '<a href="/collections/all" class="btn btn-primary">Shop the Drop</a>' +
            '</div>';
          return;
        }

        // Remove the row if qty = 0, or update it
        if (qty === 0) {
          if (row) row.remove();
        } else {
          // Find the updated item in the cart response
          var updated = null;
          for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].key === key) { updated = cart.items[i]; break; }
          }
          if (updated && row) {
            var qtyDisplay = row.querySelector('.qty-display[data-key="' + key + '"]');
            var priceEl    = row.querySelector('.cart-item__price[data-key="' + key + '"]');
            if (qtyDisplay) qtyDisplay.textContent = updated.quantity;
            if (priceEl)    priceEl.textContent    = moneyFormat(updated.line_price);
            row.classList.remove('is-updating');
          }
        }

        // Update summary totals
        if (countEl)    countEl.textContent    = cart.item_count;
        if (subtotalEl) subtotalEl.textContent = moneyFormat(cart.total_price);
        if (totalEl)    totalEl.textContent    = moneyFormat(cart.total_price);
      })
      .catch(function() {
        if (row) row.classList.remove('is-updating');
      });
    }

    // Delegated click on qty buttons
    itemsEl.addEventListener('click', function(e) {
      var btn = e.target.closest('.cart-qty-btn');
      if (!btn) return;

      var key    = btn.dataset.key;
      var action = btn.dataset.action;
      var qtyEl  = itemsEl.querySelector('.qty-display[data-key="' + key + '"]');
      if (!qtyEl) return;

      var current = parseInt(qtyEl.textContent, 10) || 1;
      var next    = action === 'plus' ? current + 1 : current - 1;
      if (next < 0) next = 0; // 0 triggers remove

      cartChange(key, next);
    });

    // Delegated click on remove buttons
    itemsEl.addEventListener('click', function(e) {
      var btn = e.target.closest('.cart-item__remove');
      if (!btn) return;
      cartChange(btn.dataset.key, 0);
    });
  }

  /* ── Scroll-reveal for product cards ─────────────────── */
  function initScrollReveal() {
    var cards = document.querySelectorAll('.product-card');
    if (!cards.length) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var idx = Array.from(cards).indexOf(entry.target);
          setTimeout(function() { entry.target.classList.add('in-view'); }, (idx % 4) * 60);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    cards.forEach(function(card) { observer.observe(card); });
  }

  /* ── Filter tabs ──────────────────────────────────────── */
  function initFilterTabs() {
    var tabs  = document.querySelectorAll('.filter-tab');
    var cards = document.querySelectorAll('.product-card[data-type]');
    if (!tabs.length || !cards.length) return;
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        tabs.forEach(function(t) { t.classList.remove('active'); });
        tab.classList.add('active');
        var filter = tab.dataset.filter;
        cards.forEach(function(card) {
          card.style.display = (filter === 'all' || card.dataset.type === filter) ? '' : 'none';
        });
      });
    });
  }

  /* ── Mobile nav ───────────────────────────────────────── */
  function initMobileNav() {
    var nav      = document.querySelector('.mobile-nav');
    var openBtn  = document.querySelector('.header-menu-btn');
    var closeBtn = document.querySelector('.mobile-nav-close');
    var overlay  = document.querySelector('.mobile-nav-overlay');
    if (!nav || !openBtn) return;
    function openNav()  { nav.classList.add('open');    document.body.style.overflow = 'hidden'; }
    function closeNav() { nav.classList.remove('open'); document.body.style.overflow = ''; }
    openBtn.addEventListener('click', openNav);
    if (closeBtn) closeBtn.addEventListener('click', closeNav);
    if (overlay)  overlay.addEventListener('click', closeNav);
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeNav(); });
  }

  /* ── Initial cart badge count ─────────────────────────── */
  function initCartCount() {
    fetchCart(function(cart) { updateCartBadge(cart.item_count); });
  }

  /* ── Product page gallery thumbnails ──────────────────── */
  function initProductGallery() {
    var thumbs = document.querySelectorAll('.product-gallery__thumb');
    var main   = document.querySelector('#product-main-img');
    if (!thumbs.length || !main) return;
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        thumbs.forEach(function(t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        // Prefer full-quality URL stored on the thumb; fall back to thumb src
        var fullSrc = thumb.getAttribute('data-full-src');
        var img = thumb.querySelector('img');
        if (fullSrc) {
          main.src = fullSrc;
        } else if (img) {
          main.src = img.src;
        }
      });
    });
  }

  /* ── Product page option swatches ─────────────────────── */
  function initOptionSelectors() {
    document.querySelectorAll('[data-product-root]').forEach(function(root) {
      var variantsEl = root.querySelector('[data-product-variants]');
      var form       = root.querySelector('[data-product-form]');
      var groups     = Array.from(root.querySelectorAll('.option-swatches'));
      var variantId = form && form.querySelector('[data-variant-id]');
      var addButton = form && form.querySelector('[data-add-to-cart]');
      var priceEl   = root.querySelector('[data-current-price]');
      var compareEl = root.querySelector('[data-compare-price]');
      var mainImage = root.querySelector('#product-main-img');
      if (!variantsEl || !form || !variantId || !addButton || !groups.length) return;

      var variants;
      try {
        variants = JSON.parse(variantsEl.textContent);
      } catch (error) {
        return;
      }

      function getSelectedOptions() {
        return groups.map(function(group) {
          var active = group.querySelector('.option-swatch.active');
          return active ? active.dataset.value : '';
        });
      }

      function optionsMatch(variantOptions, selectedOptions) {
        return variantOptions.every(function(option, index) {
          return option === selectedOptions[index];
        });
      }

      function updateSwatchAvailability(selectedOptions) {
        groups.forEach(function(group, groupIndex) {
          group.querySelectorAll('.option-swatch').forEach(function(swatch) {
            var possibleOptions = selectedOptions.slice();
            possibleOptions[groupIndex] = swatch.dataset.value;
            var hasAvailableVariant = variants.some(function(variant) {
              return variant.available && optionsMatch(variant.options, possibleOptions);
            });
            swatch.classList.toggle('sold-out', !hasAvailableVariant);
            swatch.setAttribute('aria-disabled', hasAvailableVariant ? 'false' : 'true');
          });
        });
      }

      function updateVariant() {
        var selectedOptions = getSelectedOptions();
        var variant = variants.find(function(candidate) {
          return optionsMatch(candidate.options, selectedOptions);
        });

        updateSwatchAvailability(selectedOptions);

        if (!variant) {
          variantId.value = '';
          addButton.disabled = true;
          addButton.textContent = 'Unavailable';
          if (compareEl) compareEl.hidden = true;
          return;
        }

        variantId.value = variant.id;
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
        if (priceEl) priceEl.textContent = variant.price;
        if (compareEl) {
          compareEl.textContent = variant.compareAtPrice || '';
          compareEl.hidden = !variant.compareAtPrice;
        }
        if (mainImage && variant.featuredImage) mainImage.src = variant.featuredImage;

        variantId.dispatchEvent(new Event('change', { bubbles: true }));
      }

      groups.forEach(function(group) {
        group.querySelectorAll('.option-swatch').forEach(function(swatch) {
          swatch.addEventListener('click', function() {
            group.querySelectorAll('.option-swatch').forEach(function(item) {
              item.classList.remove('active');
              item.setAttribute('aria-pressed', 'false');
            });
            swatch.classList.add('active');
            swatch.setAttribute('aria-pressed', 'true');

            var label = swatch.closest('.product-options');
            var selectedLabel = label && label.querySelector('.option-label strong');
            if (selectedLabel) selectedLabel.textContent = swatch.dataset.value;
            updateVariant();
          });
        });
      });

      form.addEventListener('submit', function(event) {
        if (!variantId.value || addButton.disabled) event.preventDefault();
      });

      updateVariant();
    });
  }

  /* ── Product page qty +/− (plain DOM, not AJAX) ───────── */
  function initQtySelector() {
    document.querySelectorAll('.qty-selector:not([data-cart])').forEach(function(wrap) {
      var input    = wrap.querySelector('.qty-input');
      var minusBtn = wrap.querySelector('[data-action="minus"]');
      var plusBtn  = wrap.querySelector('[data-action="plus"]');
      if (!input) return;
      if (minusBtn) minusBtn.addEventListener('click', function() {
        var v = parseInt(input.value, 10);
        if (v > 1) input.value = v - 1;
      });
      if (plusBtn) plusBtn.addEventListener('click', function() {
        input.value = parseInt(input.value, 10) + 1;
      });
    });
  }

  /* ── Header shadow on scroll ──────────────────────────── */
  function initHeaderScroll() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    window.addEventListener('scroll', function() {
      header.style.boxShadow = window.scrollY > 10 ? '0 2px 24px rgba(0,0,0,0.4)' : '';
    }, { passive: true });
  }

  /* ── Boot ─────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function() {
    initScrollReveal();
    initFilterTabs();
    initMobileNav();
    initProductGallery();
    initOptionSelectors();
    initQtySelector();
    initHeaderScroll();
    initCartCount();
    initCardATC();
    initCartControls();
  });

}());
